<template>
  <div class="multiple-choice-type">
    <div
      class="form-group"
    >
      <label class="flex justify-around label-option">
        <span>{{ $i18nPresenter.t('Heading') }}</span>
        <TextAlignEdit v-if="slideActive.id" />
      </label>
      <div class="mb-2 input-group input-option">
        <InputText
          :val="slideActive.title"
          @interface="updateSlide"
          :place-holder="$i18nPresenter.t('Slide heading…')"
          spellcheck="false"
          :id-name="'title-slide-edit'"
          :index="''"
          :limit="titleLimit"
          :type="'input-title'"
          :inputId="`slide-title-${slideActive.id}`"
        />
      </div>
      <!-- Question description -->
      <div class="title-desc">
        <a
          class="mb-0 right-col--link title-desc-link"
          @click="_openEditDescription"
          v-show="!descIsOpen"
        >{{ $i18nPresenter.t('Add a longer description') }}</a>
        <div class="title-desc-edit-wrapper" v-show="descIsOpen">
          <p class="mb-2 title-desc-info">
            {{ noteTitleDes }}
          </p>
          <TextArea
            v-if="descShowUndo"
            @interface="updateSlide"
            :val="slideActive.titleDesc"
            :place-holder="titleDesPlaceholder"
            :rows="subheadingRow"
            :limit="descLimit"
            :id-name="'title-desc-edit'"
            :index="''"
          />
        </div>
      </div>
    </div>

    <SpinnerWheelEntryInput />

    <SpinnerWheelTimeConfig />

    <div
      class="form-check form-check-inline"
    >
      <SpinnerWheelAutoFillToggle placement="check-participant-name-setting" />

      <div class="custom-control custom-checkbox" v-if="slideActive.metadata">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-repeat-entries"
          v-model="dataCheckDuplicateEntries"
          @change="toggleRepeatEntries()"
        >
        <label
          class="custom-control-label"
          for="check-repeat-entries"
        >{{ $i18nPresenter.t('Duplicate entries') }}</label>
        <aha-badge
          label="NEW"
          size="2xs"
          class="bg-primary-90 ml-2.5 cursor-pointer loop-accordion__badge"
        />
        <select
          :class="{'disabled': !dataCheckDuplicateEntries}"
          class="select-loop-entry w-full pr-8 border rounded outline-none appearance-none cursor-pointer focus:bg-primary-20 focus:border-primary-90 bg-base-0 focus:outline-none border-secondary-20"
          v-model="dataLoopEntry"
          @change="changeLoopEntry"
        >
          <option :value="2" selected>
            {{ $i18nPresenter.t('1 time') }}
          </option>
          <option :value="3">
            {{ $i18nPresenter.t('2 times') }}
          </option>
          <option :value="4">
            {{ $i18nPresenter.t('3 times') }}
          </option>
          <option :value="5">
            {{ $i18nPresenter.t('4 times') }}
          </option>
          <option :value="6">
            {{ $i18nPresenter.t('5 times') }}
          </option>
          <option :value="7">
            {{ $i18nPresenter.t('6 times') }}
          </option>
          <option :value="8">
            {{ $i18nPresenter.t('7 times') }}
          </option>
          <option :value="9">
            {{ $i18nPresenter.t('8 times') }}
          </option>
          <option :value="10">
            {{ $i18nPresenter.t('9 times') }}
          </option>
          <option :value="11">
            {{ $i18nPresenter.t('10 times') }}
          </option>
        </select>
        <aha-icon
          v-if="dataCheckDuplicateEntries"
          class="select-loop-entry__icon absolute ml-auto pointer-events-none top-4 right-3"
          name="arrow"
          viewBox="0 0 24 24"
          width="12"
          height="12"
        />
      </div>

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-profanity-filter"
          v-model="presentation.filteringProfanity"
          @change="toggleProfanityFilter()"
          :disabled="isDisableWhenNotOwner"
        >
        <label
          class="custom-control-label"
          for="check-profanity-filter"
        >{{ $i18nPresenter.t('Filter profanity') }}</label>
        <span class="pl-1 title-table-presentation-tooltip">
          <b-button
            v-tooltip="$i18nPresenter.t('Hide inappropriate words submitted by the audience on all slides')"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-hide-entry"
          v-model="presentation.isHideEntrySpinnerWheen"
          @change="toggleHideEntry()"
        >
        <label
          class="custom-control-label"
          for="check-hide-entry"
        >{{ $i18nPresenter.t('Hide entry board') }}</label>
        <span class="pl-1 title-table-presentation-tooltip">
          <b-button
            v-tooltip="hideEntryBoardTooltip"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Config from '@/config'
import Socket from '@/socket'
import slideApi from '@/api/slide'
import PresentationApi from '@/api/presentation'

import InputText from '@/components/presentations/InputText'
import TextArea from '@/components/presentations/TextArea'
import Utils from '@/util'
import TextAlignEdit from '@/components/presentations/TextAlignEdit'
import SpinnerWheelTimeConfig from './SpinnerWheelTimeConfig.vue'
import SpinnerWheelAutoFillToggle from './SpinnerWheelAutoFillToggle.vue'
import SpinnerWheelEntryInput from './SpinnerWheelEntryInput.vue'

// api
import eventCategories from '@/constant/eventCategories'
import EventBus from '../../../eventBus'
import UndoRedoMixin from '@/mixins/undo-redo/UndoRedoMixin'
import UpdateTitleSlideMixin from '@/mixins/undo-redo/UpdateTitleSlideMixin'

export default {
  components: {
    InputText,
    TextArea,
    TextAlignEdit,
    SpinnerWheelTimeConfig,
    SpinnerWheelAutoFillToggle,
    SpinnerWheelEntryInput,
  },
  mixins: [UndoRedoMixin, UpdateTitleSlideMixin],
  data() {
    const slideType = this.$store.state.slideActive.type
    let limit = 150
    let subheadingRow = 2
    if (slideType === 'textSlide') {
      limit = 500
      subheadingRow = 10
    }
    let titleLimit = 50
    if (slideType === 'pickAnswer') {
      titleLimit = 150
    }

    return {
      dataLoopEntry: 2,
      testKey: true,
      key: null,
      isConfirmClean: false,
      subheadingLimit: limit,
      descLimit: 250,
      subheadingRow,
      dataConfirm: {},
      isConfirmDelete: false,
      titleLimit,
      descIsOpen: false,
      descShowUndo: true,
      titleDesPlaceholder: 'Description for your question…',
      noteTitleDes:
        "The longer description will be showed on your audience's devices. You can also show it while presenting by hovering your question title.",
      pickmoreTooltip:
        'The player must pick all and only correct options to be rewarded points',
      queueUpdateTitle: [],
      isRunningQueueUpdateTitle: false,
      isLockedUpdateTitle: false,
      dataCheckDuplicateEntries: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters(['isDisableWhenNotOwner']),
    hideEntryBoardTooltip() {
      return this.$i18nPresenter.t('Hide the entry board next to the spinner wheel after clicking PRESENT button')
    },
    loopEntry() {
      return this.$store.state.slideActive && this.$store.state.slideActive.metadata && this.$store.state.slideActive.metadata.loopEntry
    },
  },
  created() {
    if (!this.slideActive.metadata) {
      this.updateSlideActiveAction({
        metadata: {},
      })
    }
  },
  mounted() {
    this.registerHistory()
    this.dataLoopEntry = 2
    if (this.loopEntry && this.loopEntry !== 1) {
      this.dataLoopEntry = this.loopEntry
    }
    if (this.slideActive.titleDesc) {
      this.descIsOpen = true
    }

    this.dataCheckDuplicateEntries = false
    if (this.slideActive && this.slideActive.metadata) {
      if (
        this.slideActive.metadata.checkDuplicateEntries ||
          (
        // TH convert các data cũ checkRepeatEntries
            (this.$store.state.slideActive.metadata.checkDuplicateEntries === undefined) &&
            this.slideActive.metadata.checkRepeatEntries &&
              this.slideActive.metadata.loopEntry &&
              this.$store.state.slideActive.metadata.loopEntry !== 1
          )
      ) {
        this.dataCheckDuplicateEntries = true
      }
    }
  },

  methods: {
    ...mapActions(['updateSlideActiveAction']),
    async toggleRepeatEntries() {
      const payload = {
        accessCode: this.presentation.uniqueAccessCode,
        metadata: {
          ...this.slideActive.metadata,
          checkDuplicateEntries: this.dataCheckDuplicateEntries,
        },
        presenting: this.$store.getters.isPresenting,
        socketId: Socket.getSocketId(),
      }
      this.$store.dispatch('setSyncPresentation', 1)
      try {
        await slideApi.updateSlideById(this.slideActive.id, payload)
        const index = this.presentation.slides.findIndex((item) => {
          return item.id === this.slideActive.id
        })
        if (index !== -1) {
          this.presentation.slides[index].metadata = this.slideActive.metadata
        }

        const currentMetaData = JSON.parse(JSON.stringify(this.slideActive.metadata))
        const newMetaData = {
          ...currentMetaData,
          checkDuplicateEntries: this.dataCheckDuplicateEntries,
        }
        this.updateSlideActiveAction({
          metadata: newMetaData,
        })

        this.$store.dispatch('setSyncPresentation', 2)
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)
      }

      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        `Side right > Spinner Wheel > Check mutiply entry list: ${this.dataCheckDuplicateEntries}`,
      )
    },
    async changeLoopEntry() {
      const currentMetaData = JSON.parse(JSON.stringify(this.slideActive.metadata))
      const newMetaData = {
        ...currentMetaData,
        loopEntry: this.dataLoopEntry,
      }
      const payload = {
        accessCode: this.presentation.uniqueAccessCode,
        presenting: this.$store.getters.isPresenting,
        socketId: Socket.getSocketId(),
        metadata: newMetaData,
      }
      this.$store.dispatch('setSyncPresentation', 1)
      try {
        await slideApi.updateSlideById(this.slideActive.id, payload)
        this.$store.dispatch('setSyncPresentation', 2)
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)
        return false
      }
      const currentLoopEntry = this.loopEntry
      this.updateSlideActiveAction({
        metadata: newMetaData,
      })
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Side right > Spinner Wheel > Loop Entries Changed',
        'Right column',
        this.dataLoopEntry,
        { changed: `From ${currentLoopEntry} To ${this.dataLoopEntry}` },
      )
    },
    callbackAfterRestore(data) {
      if (data.value !== undefined) {
        EventBus.$emit(`update-right-column-for-slide-title-${this.slideActive.id}`, data.value)
      }
      if (data.titleDesc) {
        this.descShowUndo = false
        setTimeout(() => {
          this.descShowUndo = true
        }, 50)
      }
    },
    async updateSlideInQueue() {
      if (this.isRunningQueueUpdateTitle) {
        return
      }
      this.isRunningQueueUpdateTitle = true
      while (this.queueUpdateTitle.length) {
        const item = this.queueUpdateTitle.shift()
        // eslint-disable-next-line no-await-in-loop
        await this.updateSlide(item, true, false)
      }
      this.isRunningQueueUpdateTitle = false
    },
    async updateSlide(data, isBackup = true, isTrust = true) {
      if (this.isLockedUpdateTitle) {
        if (isTrust) {
          this.queueUpdateTitle.push(data)
        }
        return
      }
      this.isLockedUpdateTitle = true
      await new Promise((resolve) => {
        if (isBackup) {
          this.backupUpdateSlide(data)
        }
        const payload = {}
        if (data.value) {
          payload.title = data.value
          payload.titleHTML = data.value
        } else if (data.value === '') {
          payload.title = ' '
          payload.titleHTML = ' '
        }
        if (data.subheading) {
          payload.subheading = data.subheading
        } else if (data.subheading === '') {
          payload.subheading = ' '
        }
        if (data.titleDesc && data.titleDesc.replace(/\s/g, '') !== '') {
          payload.titleDesc = data.titleDesc
        } else if (data.titleDesc === '') {
          payload.titleDesc = null
        }

        this.$store.dispatch('setSyncPresentation', 1)
        payload.presentationId = this.$store.state.presentation.id
        payload.accessCode = this.$store.state.presentation.uniqueAccessCode
        payload.socketId = Socket.getSocketId()
        payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage
        const slideId = this.slideActive.id
        this.$http
          .put(Config.api.updateSlide + this.slideActive.id, payload)
          .then(
            () => {
              const index = this.$store.state.presentation.slides.findIndex(
                (item) => {
                  return item.id === slideId
                },
              )

              if (index === -1) return
              const slideType = this.slideActive.type === 'pickAnswer' ? this.slideActive.slideType : this.slideActive.type
              if (payload.title) {
                this.$store.state.presentation.slides[index].title =
                        payload.title
                Utils.mixpanelTracking(
                  eventCategories.PRESENTATION_EDITOR,
                  'Edit slide title',
                  'Right column',
                  `Slide type: ${slideType}`,
                )
              }
              if (payload.subheading) {
                this.$store.state.presentation.slides[index].subheading =
                        payload.subheading
                Utils.mixpanelTracking(
                  'Slide',
                  'Edit text slide',
                  'Done editing subheading',
                )
              }
              if (payload.titleDesc || payload.titleDesc === null) {
                this.$store.state.presentation.slides[index].titleDesc =
                        payload.titleDesc
                Utils.mixpanelTracking(
                  'Slide',
                  'Edit text slide',
                  'Done editing question description',
                )
              }

              if (slideId === this.slideActive.id) {
                this.$store.dispatch('updateSlideActive', payload)
              }

              this.$store.dispatch('setSyncPresentation', 2)
              resolve()
            },
            () => {
              this.$store.dispatch('setSyncPresentation', 3)
            },
          )
      })
      this.isLockedUpdateTitle = false
      this.updateSlideInQueue()
    },

    async _updatePresentation(payload) {
      payload.socketId = Socket.getSocketId()
      await PresentationApi.updatePresentationByPresentationId(this.presentation.id, payload)
    },

    async toggleProfanityFilter() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        `Side right > Profanity Filter > ${this.presentation.filteringProfanity ? 'Filter on' : 'Filter off'}`,
      )
      this._updatePresentation({
        filteringProfanity: this.presentation.filteringProfanity,
      })
    },

    async toggleHideEntry() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        `Side right > Hide Entry Board > ${this.presentation.isHideEntrySpinnerWheen ? 'Hide entry on' : 'Hide entry off'}`,
      )
      this._updatePresentation({
        isHideEntrySpinnerWheen: this.presentation.isHideEntrySpinnerWheen,
      })
    },

    _openEditDescription() {
      this.descIsOpen = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.text-decoration {
  text-decoration: underline;
  cursor: pointer;
}
.input-group {
  user-select: none;
}

.custom-checkbox {
  margin-bottom: 1rem;
}

.form-check-inline {
  display: block;
  margin-bottom: 16px;
  &.form-check-font-scpro {
    margin-bottom: 40px;
  }
  @media (max-width: 320px) {
    &.hide-result-form {
      margin-right: 0;
      .button-show-all {
        margin-left: -2.5px;
      }
    }
  }
}

.custom-control-label {
  cursor: pointer;
}

.label-option-small {
  font-size: 14px !important;
  color: #313131 !important;
  padding-left: 10px;
  padding-left: 23px;
}
.input-option {
  & ::v-deep .input-style {
    width: min-content;
  }
}

.disabled {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;

  input, label {
    cursor: not-allowed;
  }
}

.not-allowed {
  cursor: not-allowed;
}

.title-desc {
  .title-desc-link {
    font-size: 0.875em;
  }
  .title-desc-edit-wrapper {
    .title-desc-info {
      opacity: 0.7;
      font-size: 0.875em;
    }
  }
}

.select-loop-entry {
  margin-top: 10px;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 12px;
  padding-right: 12px;
}

.select-loop-entry__icon {
  top: 2.9rem;
}

.loop-accordion__badge{
  vertical-align: middle;
  margin-left: 4px;
}
</style>
